export class CorrelativoOsFilter {
  gestion?: number;
  sigla?: string;
  correlativo_actual?: number;
  tipo_correlativo?: string;
  oficina?: string;
}
